/* Decorative hover/focus reveal. Product links retain native click and touch behavior. */
if (!customElements.get('one-product-photo')) {
  customElements.define('one-product-photo', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.link = this.querySelector('.one-product-photo__link');
      this.template = this.querySelector('template[data-one-photo-reveal]');
      if (!this.link || !this.template) return;
      const options = { signal: this.abort.signal };
      this.hovered = false;
      this.focused = false;
      this.link.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || navigator.connection?.saveData) return;
        this.hovered = true;
        this.update();
      }, options);
      this.link.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
      this.link.addEventListener('focus', () => {
        this.focused = !navigator.connection?.saveData;
        this.update();
      }, options);
      this.link.addEventListener('blur', () => { this.focused = false; this.update(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.hasAttribute('data-revealed')) return;
        this.hovered = this.focused = false;
        this.update();
      }, options);
    }

    update() {
      if (this.failed) return;
      const reveal = this.hovered || this.focused;
      if (reveal) this.loadReveal();
      this.toggleAttribute('data-revealed', reveal);
    }

    loadReveal() {
      if (this.loaded) return;
      const fragment = this.template.content.cloneNode(true);
      const overlay = fragment.querySelector('.one-product-photo__reveal');
      const image = fragment.querySelector('img');
      if (!overlay || !image) return;
      this.loaded = true;
      image.loading = 'eager';
      const ready = () => overlay.classList.add('is-ready');
      image.addEventListener('load', ready, { once: true, signal: this.abort.signal });
      image.addEventListener('error', () => {
        this.failed = true;
        this.removeAttribute('data-revealed');
      }, { once: true, signal: this.abort.signal });
      this.link.append(fragment);
      if (image.complete && image.naturalWidth) ready();
    }

    disconnectedCallback() { this.abort?.abort(); }
  });
}
